import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import accessRight from '../../utils/functions/accessRight';
import { NotAuthorized } from '../../components/Error';
import { SettingPAMS as SettingPAMSView } from '../../views/PAMS';

export function SettingPAMS() {
  const module = 'PAMS';
  const prefix = '/setting/pams';
  const name = 'ตั้งค่าระบบ';
  const me = useSelector((state) => state.me);
  const availableModule = useSelector((state) => state.availableModule);

  if (accessRight(me, module, 1, availableModule)) {
    return (
      <div>
        <Route exact path={`${prefix}/module-setting`}>
          <SettingPAMSView
            title="ตั้งค่าระบบเงินเดือนและการจ่ายค่าตอบแทน"
            subtitle={name}
          />
        </Route>
      </div>
    );
  }
  return (
    <div>
      <Route path="*">
        <NotAuthorized />
      </Route>
    </div>
  );
}

export default SettingPAMS;
